import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import {
  GenericComponentsModule,
  ResizeHandleModule,
} from '@helios/generic-components'
import {
  NgbDropdownModule,
  NgbNavModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap'
import { TableLayoutModule } from '@northfork/ag-grid-angular'
import { ButtonModule } from '@northfork/ng-basics'
import { WorkbenchGridModule } from './components/workbench-grid/workbench-grid.module'
import { Positions2PanelComponent } from './positions-2-panel.component'
import { PositionComparisonComponent } from './sub-panels/comparison/position-comparison.component'
import { PositionDetailComponent } from './sub-panels/position-detail/position-detail.component'

@NgModule({
  imports: [
    CommonModule,
    // For the Position Comparison sub-panel's Difference-key select.
    FormsModule,
    NgbNavModule,
    // For the disabled Historical Balance tab's "not yet supported" tooltip.
    NgbTooltipModule,
    // For the Position Detail sub-panel's COLUMN GROUPS dropdown and its toolbar kebab.
    NgbDropdownModule,
    // `nf-icon-button`, so that kebab is the same button component every other Helios menu uses.
    ButtonModule,
    // GenericComponentsModule supplies hs-panel-card, the shared empty-state card.
    GenericComponentsModule,
    ResizeHandleModule,
    // For the Position Comparison sub-panel's grid (nf-table-layout).
    TableLayoutModule,
    WorkbenchGridModule,
    // nf-table-layout, for the Position Detail sub-panel's ag-Grid table. WorkbenchGridModule
    // imports it too but does not re-export it, so it is declared here for this module's own
    // components rather than relied on transitively.
    TableLayoutModule,
  ],
  declarations: [
    Positions2PanelComponent,
    PositionComparisonComponent,
    PositionDetailComponent,
  ],
  exports: [Positions2PanelComponent],
})
export class Positions2Module {}

export { Positions2PanelComponent }
